import getItemStyles from '../../../utils/item-styles.js';
import timelineDisplayOrder from './timelineDisplayOrder.js';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck.js';

/**
 * Returns a meal item that can be displayed in the one to two day schedule. The styling will be created by calling getItemStyle.
 * @param {*} resource
 * @param {*} dayType
 * @param {*} mealStartTime
 * @param {*} mealEndTime
 */
const generateMeal = (resource, dayType, mealStartTime, mealEndTime, scheduleFormat) => {
  const { rId } = resource;
  const { rdtId } = dayType;
  const { mealId, red, isApproved } = dayType.tour.meal;
  const mealStyle = getItemStyles('meal');

  const meal = {
    id: mealId,
    rdtId,
    itemType: 'meal',
    group: rId,
    start_time: mealStartTime,
    end_time: mealEndTime,
    backgroundColor: dayType.tour.meal.isApproved ? 'gray': !red ? mealStyle.backgroundColor : 'red',
    borderStyle: mealStyle.borderStyle,
    borderColor: mealStyle.borderColor,
    timelineDisplayOrder: timelineDisplayOrder.tour,
    isApproved
  };
  return meal;
}

export default generateMeal;
